import type { TypeBadgeProps } from '@thefarmersfront/kitchen';

/**
 * 출고 주문 조회에서 사용되는 페이지네이션 값들
 */
export const INITIAL_ORDER_PAGE_SIZE = 50;
export const INITIAL_ORDER_PAGE_OFFSET = 0;

export const ORDER_PAGE_SIZE = {
  50: {
    value: 50,
    text: '50개',
  },
  100: {
    value: 100,
    text: '100개',
  },
  200: {
    value: 200,
    text: '200개',
  },
} as const;

export type TypeOrderPageSize = keyof typeof ORDER_PAGE_SIZE;

/**
 * 출고주문조회 > 키워드 타입
 */
export const KEYWORD_TYPE = {
  CLIENT_ORDER_CODE: 'CLIENT_ORDER_CODE',
  OUTBOUND_ORDER_CODE: 'OUTBOUND_ORDER_CODE',
  ORDERER_ID: 'ORDERER_ID',
  RECEIVER_NAME: 'RECEIVER_NAME',
} as const;

/**
 * 출고주문조회 > 기간 타입
 */
export const PERIOD_TYPE = {
  DELIVERY_DATE: 'DELIVERY_DATE',
  PAYMENT_AT: 'PAYMENT_AT',
} as const;

export const KEYWORD_PLACE_HOLDER: { [id: string]: string } = {
  CLIENT_ORDER_CODE: '복수 입력 시 ","로 구분',
  OUTBOUND_ORDER_CODE: '복수 입력 시 ","로 구분',
  ORDERER_ID: '입력',
  RECEIVER_NAME: '입력',
} as const;

/**
 * 출고주문조회 > 출고 상태에 따른 뱃지 컬러
 */
export const OUTBOUND_STATUS_BADGE_COLOR: { [key: string]: TypeBadgeProps['color'] } = {
  READY: 'secondary',
  PRODUCING: 'info',
  COMPLETED: 'success',
  CANCELED: 'error',
} as const;

/**
 * 출고주문조회 > 주문 등록 제한 시간
 */
export const ORDER_UPLOAD_RESTRICTED_HOUR_START = 22;
export const ORDER_UPLOAD_RESTRICTED_HOUR_END = 0;

/**
 * 출고주문조회 > 출고 상태
 */
export const OUTBOUND_STATUS = {
  READY: {
    code: 'READY',
    name: '대기중',
  },
  PRODUCING: {
    code: 'PRODUCING',
    name: '진행중',
  },
  COMPLETED: {
    code: 'COMPLETED',
    name: '완료',
  },
  CANCELED: {
    code: 'CANCELED',
    name: '취소',
  },
} as const;

export const MAX_KEYWORD_COUNT = 10;
